import { useState, useEffect } from "react";
import "./bdmcontrols.css";

function ProductQnATable() {
  const [qnaList, setQnaList] = useState([]);
  const [config, setConfig] = useState(null);

  // Load config.json
  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch((err) => console.error("Error loading config:", err));
  }, []);

  // Fetch QnA
  useEffect(() => {
    if (!config) return;

    fetch(`${config.BASE_URL}${config.FETCH_QUESTIONS}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({}),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setQnaList(data.qna);
        } else {
          alert(data.message || "Failed to fetch QnA");
        }
      })
      .catch(() => alert("Error fetching QnA"));
  }, [config]);

  const handleAnswerChange = (index, value) => {
    const updated = [...qnaList];
    updated[index].answer = value;
    setQnaList(updated);
  };

  const handleSave = (qa_id, answer) => {
  if (!config) return;
  fetch(`${config.BASE_URL}${config.SAVE_ANSWER}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ qa_id, answer }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.success) {
        alert("Answer saved successfully!");
        // Remove the answered row from qnaList
        setQnaList((prevList) => prevList.filter((q) => q.qa_id !== qa_id));
      } else {
        alert(data.message || "Failed to save answer");
      }
    })
    .catch(() => alert("Error saving answer"));
};

const handleSendMail = (qa_id, answer) => {
    if (!config) return;
    fetch(`${config.BASE_URL}${config.SEND_ANSWER_MAIL}`, { 
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ qa_id, answer }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          alert("Answer sent via email!");
        } else {
          alert(data.message || "Failed to send email");
        }
      })
      .catch(() => alert("Error sending email"));
  };



  return (
    <div className="qna-container">
      <h2>All Product Questions</h2>

      <table className="qna-table">
        <thead>
          <tr>
            <th>Qna_id</th>
            <th>Product</th>
            <th>Question</th>
            <th>Answer</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {qnaList.length === 0 ? (
            <tr>
              <td colSpan="4" style={{ textAlign: "center" }}>
                No QnA available
              </td>
            </tr>
          ) : (
            qnaList.map((item, index) => (
              <tr key={item.qa_id}>
                <td>{item.qa_id}</td>
                <td>{item.product_title}</td>
                <td>{item.question}</td>
                <td>
                  <textarea
                    value={item.answer || ""}
                    onChange={(e) => handleAnswerChange(index, e.target.value)}
                    placeholder="Enter answer"
                    rows={3}
                    style={{ width: "100%", resize: "vertical" }}
                  />
                </td>
                <td>
                  <button
                    className="save-btn"
                    onClick={() => handleSave(item.qa_id, item.answer)}
                  >
                    Save
                  </button>
                  <button
                    className="save-btn"  style={{ marginLeft: "20px" }}
                    onClick={() => handleSendMail(item.qa_id, item.answer)}
                  >
                    Send Mail
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default ProductQnATable;
